import React from 'react';

/**
 * EstimatSentModal - Modal som visas när estimat har skickats till kund
 * Specifik för estimat-flödet
 */
const EstimatSentModal = ({ show, onClose, customerName, projectType, bestallare2Name, isUpdate, version }) => {
  if (!show) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
      <div className="bg-white rounded-xl shadow-xl max-w-md w-full mx-4 overflow-hidden">
        {/* Header med grön bakgrund */}
        <div className="bg-green-50 px-6 py-4 border-b border-green-200">
          <div className="flex items-center">
            <div className="flex-shrink-0">
              <div className="w-8 h-8 bg-green-500 rounded-full flex items-center justify-center">
                <svg className="w-5 h-5 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M5 13l4 4L19 7" />
                </svg>
              </div>
            </div>
            <div className="ml-3">
              <h3 className="text-lg font-semibold text-green-900">
                {isUpdate ? 'Uppdaterat estimat skickat!' : 'Estimat skickat!'}
              </h3>
              <p className="text-sm text-green-700">
                {isUpdate ? 'Kunden har fått den uppdaterade versionen' : 'Kunden har nu fått sitt estimat'}
              </p>
            </div>
          </div>
        </div>
        
        {/* Content */}
        <div className="px-6 py-4">
          <div className="text-sm text-gray-600 space-y-3">
            <p>
              <strong>{isUpdate ? `Uppdaterat estimat ${version}` : `Estimatet`} för {projectType}</strong> har skickats till <strong>{customerName}</strong>{bestallare2Name ? (<span> och <strong>{bestallare2Name}</strong></span>) : null}.
            </p>
            
            {isUpdate ? (
              <div className="bg-orange-50 p-3 rounded-lg border border-orange-200">
                <p className="text-orange-800 text-sm">
                  <strong>📧 Automatiskt skickat:</strong>
                </p>
                <ul className="text-orange-700 text-sm mt-1 space-y-1">
                  <li>• E-post om uppdaterat estimat version {version}</li>
                  <li>• Notifikation i kundportalen</li>
                </ul>
              </div>
            ) : (
              <div className="bg-blue-50 p-3 rounded-lg border border-blue-200">
                <p className="text-blue-800 text-sm">
                  <strong>📧 Automatiskt skickat:</strong>
                </p>
                <ul className="text-blue-700 text-sm mt-1 space-y-1">
                  <li>• Välkomstmail med inloggningsuppgifter</li>
                  <li>• E-post med länk till estimatet</li>
                </ul>
              </div>
            )}
            
            <p className="text-gray-600">
              {isUpdate 
                ? 'Kunden kan nu granska den uppdaterade versionen och ta ställning till ändringarna.'
                : 'Kunden kan nu logga in i kundportalen för att granska estimatet och ge feedback.'
              }
            </p>
          </div>
        </div>
        
        {/* Footer */}
        <div className="px-6 py-4 bg-gray-50 flex justify-end">
          <button
            onClick={onClose}
            className="px-4 py-2 bg-leadme-pink text-white rounded-lg hover:bg-leadme-pink-dark transition-colors duration-200"
          >
            Stäng
          </button>
        </div>
      </div>
    </div>
  );
};

export default EstimatSentModal;
